import styled, { css } from 'styled-components';
import { EditableTextFieldCSS, hideNumberInputArrowsCSS, StyledTextField } from 'styles/common';

export const InputPaddingCSS = css`
  padding: 0.5rem 0.75rem;
`;

const EditableField = styled(StyledTextField)`
  .MuiInputBase-root {
    font-size: ${(props) => props.fontSize ?? props.theme.typography.body2.fontSize};
  }
  ${EditableTextFieldCSS};
  input {
    ${hideNumberInputArrowsCSS};
    ${InputPaddingCSS};
  }
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  margin-left: ${(props) => props.marginLeft ?? '-0.5rem'};
  ${(props) => props.theme.breakpoints.down('xs')} {
    margin-left: 10px;
    max-width: 185px;
    padding-bottom: 5px;
  }
`;

export default EditableField;
